<template>
  <div class="container">
    <!--课程学习页面-->
    <div class="xuex">
      <div class="commen">
        <div class="xuexa">
          <h6>印前色彩管理培训</h6>
          <!-- <div class="mbx pc fr">
            <p>位置：<a href="#">首页</a> &gt; <a href="#">关于</a></p>
          </div> -->
          <div class="pxnab_a bshare-custom fr">
            <img src="@/view/images/y67.png" style="cursor: pointer;" />
            <p style="color: #ffffff;">课程分享</p>
            <vshare class="pxnab_aicon" :vshareConfig="vshareConfig"></vshare>
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="xuexb">
          <div class="xuexb_video fl">
            <img src="@/view/images/y65.jpg" />
            <!--<video></video>-->
          </div>
          <div class="xuexc fr">
            <div class="xuexca">
              <p class="on">章节</p>
              <p><a href="#">章节</a></p>
              <div class="clearfix"></div>
            </div>
            <div class="xuexcb">
              <div class="xuexcb_a">
                <h6>第一章</h6>
                <div class="xuexcb_aa">
                  <a href="#">
                    <p>○ 课时1名称课时1名称</p>
                    <span>10:32</span>
                    <div class="clearfix"></div>
                  </a>
                </div>
                <div class="xuexcb_aa">
                  <a href="#">
                    <p>○ 课时1名称课时1名称</p>
                    <span>10:32</span>
                    <div class="clearfix"></div>
                  </a>
                </div>
                <div class="xuexcb_aa">
                  <a href="#">
                    <p>○ 课时1名称课时1名称</p>
                    <span>10:32</span>
                    <div class="clearfix"></div>
                  </a>
                </div>
                <div class="xuexcb_aa">
                  <a href="#">
                    <p>○ 课时1名称课时1名称</p>
                    <span>10:32</span>
                    <div class="clearfix"></div>
                  </a>
                </div>
                <div class="xuexcb_aa">
                  <a href="#">
                    <p>○ 课时1名称课时1名称</p>
                    <span>10:32</span>
                    <div class="clearfix"></div>
                  </a>
                </div>
                <div class="xuexcb_aa">
                  <a href="#">
                    <p>○ 课时1名称课时1名称</p>
                    <span>10:32</span>
                    <div class="clearfix"></div>
                  </a>
                </div>
                <div class="xuexcb_aa">
                  <a href="#">
                    <p>○ 课时1名称课时1名称</p>
                    <span>10:32</span>
                    <div class="clearfix"></div>
                  </a>
                </div>
                <div class="xuexcb_aa">
                  <a href="#">
                    <p>○ 课时1名称课时1名称</p>
                    <span>10:32</span>
                    <div class="clearfix"></div>
                  </a>
                </div>
              </div>
              <div class="xuexcb_a">
                <h6>第一章</h6>
                <div class="xuexcb_aa">
                  <a href="#">
                    <p>○ 课时1名称课时1名称</p>
                    <span>10:32</span>
                    <div class="clearfix"></div>
                  </a>
                </div>
                <div class="xuexcb_aa">
                  <a href="#">
                    <p>○ 课时1名称课时1名称</p>
                    <span>10:32</span>
                    <div class="clearfix"></div>
                  </a>
                </div>
                <div class="xuexcb_aa">
                  <a href="#">
                    <p>○ 课时1名称课时1名称</p>
                    <span>10:32</span>
                    <div class="clearfix"></div>
                  </a>
                </div>
                <div class="xuexcb_aa">
                  <a href="#">
                    <p>○ 课时1名称课时1名称</p>
                    <span>10:32</span>
                    <div class="clearfix"></div>
                  </a>
                </div>
                <div class="xuexcb_aa">
                  <a href="#">
                    <p>○ 课时1名称课时1名称</p>
                    <span>10:32</span>
                    <div class="clearfix"></div>
                  </a>
                </div>
                <div class="xuexcb_aa">
                  <a href="#">
                    <p>○ 课时1名称课时1名称</p>
                    <span>10:32</span>
                    <div class="clearfix"></div>
                  </a>
                </div>
                <div class="xuexcb_aa">
                  <a href="#">
                    <p>○ 课时1名称课时1名称</p>
                    <span>10:32</span>
                    <div class="clearfix"></div>
                  </a>
                </div>
              </div>
              <div class="xuexcb_a">
                <h6>第一章</h6>
                <div class="xuexcb_aa">
                  <a href="#">
                    <p>○ 课时1名称课时1名称</p>
                    <span>10:32</span>
                    <div class="clearfix"></div>
                  </a>
                </div>
                <div class="xuexcb_aa">
                  <a href="#">
                    <p>○ 课时1名称课时1名称</p>
                    <span>10:32</span>
                    <div class="clearfix"></div>
                  </a>
                </div>
                <div class="xuexcb_aa">
                  <a href="#">
                    <p>○ 课时1名称课时1名称</p>
                    <span>10:32</span>
                    <div class="clearfix"></div>
                  </a>
                </div>
                <div class="xuexcb_aa">
                  <a href="#">
                    <p>○ 课时1名称课时1名称</p>
                    <span>10:32</span>
                    <div class="clearfix"></div>
                  </a>
                </div>
                <div class="xuexcb_aa">
                  <a href="#">
                    <p>○ 课时1名称课时1名称</p>
                    <span>10:32</span>
                    <div class="clearfix"></div>
                  </a>
                </div>
                <div class="xuexcb_aa">
                  <a href="#">
                    <p>○ 课时1名称课时1名称</p>
                    <span>10:32</span>
                    <div class="clearfix"></div>
                  </a>
                </div>
                <div class="xuexcb_aa">
                  <a href="#">
                    <p>○ 课时1名称课时1名称</p>
                    <span>10:32</span>
                    <div class="clearfix"></div>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
    <!--留言-->
    <!-- <div class="lyan" style="margin-top: 0;">
      <div class="commen">
        <h6>给印工社留言，免费获取更多服务</h6>
        <div class="lyana">
          <input class="input1 fl" v-model="gongsi" type="text" onfocus="if(value=='您的公司') {value=''}"
                 onblur="if (value=='') {value='您的公司'}">
          <input class="input1 fl" v-model="mobile" type="text" onfocus="if(value=='您的联系方式') {value=''}"
                 onblur="if (value=='') {value='您的联系方式'}">
          <textarea class="fl" v-model="content" onfocus="if(value=='您的需求'){value=''}"
                    onblur="if (value ==''){value='您的需求'}"></textarea>
          <input class="input2 fl" type="submit" value="提交留言">
          <div class="clearfix"></div>
        </div>
      </div>
    </div> -->
    <coun-sel></coun-sel>
  </div>
</template>

<script>
import $ from 'jquery'; // 在需要使用的页面中
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
import CounSel from '@/components/counsel';

export default {
  name: 'curriculumName',
  components: {
    CounSel,
  },
  data() {
    return {
      content: '您的需求',
      mobile: '您的联系方式',
      gongsi: '您的公司',
      vshareConfig: {
        shareList: [
          // 此处放分享列表（ID）
          'more',
        ],
        common: {
          // 此处放置通用设置
        },
        share: [
          {
            // 此处放置分享按钮设置
          },
        ],
        slide: [
          // 此处放置浮窗分享设置
        ],
        image: [
          // 此处放置图片分享设置
        ],
        selectShare: [
          // 此处放置划词分享设置
        ],
      },
    };
  },
  methods: {
    init() {},
  },
  mounted() {},
  created() {
    this.init();
  },
};
</script>

<style scoped>
.pxnab_a {
  position: relative;
}
.pxnab_aicon {
  width: 100%;
  height: 23px;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 99;
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/view/curriculum.vue